import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Share|Accredible SSO|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	feature: HubFeature.ShareAccredibleBadging,
	htmlAllowed: false,
	portal: 'CP',
};

export type CPAccredibleSsoLocNames = 'CPAccredibleSsoNotificationAccredibleIdNotFound';

export const cpAccredibleSsoLocs: LocDefs<CPAccredibleSsoLocNames> = {
	CPAccredibleSsoNotificationAccredibleIdNotFound: {
		defaultValue:
			'The Accredible ID for your profile does not exist. Please contact support for assistance.',
		description: 'Notification message when Accredible ID does not exist',
		displayPath: `${pathStart}Accredible ID Not Found`,
		displayType: 'Notification',
		...sharedProperties,
	},
};

export type CPAccredibleSsoLocType = LocMap<CPAccredibleSsoLocNames>;
